import {createRoot} from 'react-dom/client'
import 'reflect-metadata';
import * as Sentry from "@sentry/react";
import {ThemeWrapper} from './ThemeWrapper';
import {AppRouter} from './AppRouter';

Sentry.init({
    enabled: process.env.NODE_ENV !== 'development',
    dsn: "https://2b30e81fd4f6024f59220b2c46f402ab@o4505194489380864.ingest.us.sentry.io/4508725017903104",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/fortaleza\.quest/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const originalError = console.error;
console.error = function (message, ...args) {
    // TODO: This is due to a bug in spinners-react
    // https://github.com/adexin/spinners-react/issues/22
    if (
        typeof message === 'string'
        && message.includes('Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead')
    ) {
        return;
    }
    originalError.apply(console, [message, ...args]);
};

const AppWithWrappers = () => {
    return <ThemeWrapper>
        <AppRouter/>
    </ThemeWrapper>
};

createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <AppWithWrappers/>
    // </StrictMode>,
)
